import * as React from 'react';
import Alert from '@mui/material/Alert';
import MailOutline from '@mui/icons-material/MailOutline';
import Switch from '@mui/material/Switch';

export interface MSProps {
    onChange:(status:boolean)=>void
}
export default function MailerSwitch(props:MSProps) {
    return ( 
        <Alert
        iconMapping={{
            success: <MailOutline fontSize="inherit" />,
          }}
        severity="success"
        action={
        <Switch onChange={ (_,checked)=>{ props.onChange(checked);} } color="success"/>
         }
        >
            Send email upon completion.
        </Alert>
    )
}

/*
        <Alert variant="outlined" severity="info"
        iconMapping={{
            success: <MailOutline fontSize="inherit" />,
        }}
        >
        <FormControlLabel control={<Switch defaultChecked />} label="Send email upon completion" />
        </Alert>
        */